import axios from "./axiosInstance";
import { UserBase } from "../types/userTypes";
import axiosInstance from "./axiosInstance";
import { ApiResponse } from "types/apiTypes";
import { AcademicYear } from "types/AcademicYearTypes";

/**
 * Get current user information
 */
export const getUserInfo = async (): Promise<UserBase> => {
  const response = await axios.get<{data : UserBase}>("/users/me");
  return response.data.data;
};

/**
 * Update user profile image
 */
export const updateUserImage = async (imageFile: File | null): Promise<UserBase> => {
  const formData = new FormData();
  if (imageFile) {
    formData.append("photo", imageFile);
  }
  
  const response = await axios.post<{data: UserBase}>("/users/update-image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.data;
};

/**
 * Update user profile information
 */
export const updateUser = async (userData: Partial<UserBase>): Promise<UserBase> => {
  const response = await axios.put<{data: UserBase}>("/users/update-info", userData);
  return response.data.data;
};

export const saveFCMToken = async (token: string): Promise<UserBase> => {
  const response = await axios.post<{data: UserBase}>("/users/save-fcm-token", { token });
  return response.data.data;
};

export const deleteFCMToken = async (token: string): Promise<UserBase> => {
  const response = await axios.post<{data: UserBase}>("/users/delete-fcm-token", { data: { token } });
  return response.data.data;
};


export const updateAcademicYear = async (academicYearId: string): Promise<AcademicYear> => {
  const response = await axiosInstance.put<ApiResponse<AcademicYear>>("/users/update-academic-year", { academicYearId });
  return response.data.data;
};

export const sendResetPassword = async (body:any): Promise<any> => {
  const response = await axios.post<ApiResponse<any>>("/users/send-reset-password",body);
  return response.data.data;
};


export const findOneByEmailAndRole = async (params:any): Promise<any> => {
  const response = await axios.get<ApiResponse<any>>("/users/search",{params});
  return response.data.data;
};


